import {
  Award,
  LayoutGrid,
  Layers,
  Link2,
  Shield,
  Shuffle,
  Target,
  TrendingUp,
  Trophy,
  Users,
  Zap,
} from "lucide-react";
import { P2P_PLATFORM_FEE_PERCENT } from "../../../config/fees";

export const P2P_SECTION_ICONS = {
  oneXTwo: Trophy,
  doubleChance: Layers,
  bothTeamsToScore: Target,
  overUnderGoals: TrendingUp,
  correctScore: LayoutGrid,
  cleanSheet: Shield,
  oddEven: Shuffle,
  teamToScore: Users,
  winToNil: Award,
  drawNoBet: Zap,
  doubleChanceAndBothTeamsToScore: Link2,
};

export const STAKE_STEP_META = [
  {
    key: "amount",
    title: "Budget, odds & min stake",
    hint: "Lock your max loss, set counter odds, and choose the minimum stake counters must put down (floor Cash 500).",
  },
  {
    key: "invites",
    title: "Inviting friends?",
    hint: "Invite codes let friends counter directly. You can also list publicly.",
  },
  {
    key: "codes",
    title: "Friend codes",
    hint: "Add up to 5 invite codes. They'll see your challenge instantly.",
  },
  {
    key: "review",
    title: "Review & launch",
    hint: `Confirm your offer before posting. Winner’s profit is charged a ${P2P_PLATFORM_FEE_PERCENT}% platform fee at settlement.`,
  },
];
